<script lang="ts" setup>
import {moveToAnchor} from "~/composables/move-to-anchor";

withDefaults(defineProps<{
  type?: 'legal' | 'orange' | 'black' | 'white'
  text: string
  url: string
  fontWeight?: 400 | 500
  isNuxtLink?: boolean
  isAnchor?: boolean
}>(), {
  type: 'orange',
  isNuxtLink: true,
  fontWeight: 400
})
</script>

<template>
  <NuxtLink
    v-if="isNuxtLink"
    class="link"
    :class="`link_${type}`"
    :to="url"
  >{{text}}</NuxtLink>
  <a
    v-else-if="!isNuxtLink && !isAnchor"
    class="link"
    :class="`link_${type}`"
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    v-html="text"
  >
  </a>
  <a
    v-else
    class="link link_anchor"
    :class="`link_${type}`"
    :href="url"
    @click.prevent="moveToAnchor(url)"
  >
    {{text}}
  </a>
</template>

<style lang="scss" scoped>
.link {
  display: inline-block;
  width: fit-content;
  font-weight: v-bind(fontWeight);

  &:active {
    @include md-breakpoint {
      background-color: $control-bg_neutral;
    }
  }

  &_anchor {
    @include md-breakpoint {
      min-width: 258px;
      padding: 14px 16px;
      text-align: center;
      background-color: $control-bg_neutral;
      color: $control-content_primary !important;
      border-radius: 8px;
    }
  }

  &_legal {
    text-decoration-skip-ink: none;
    text-decoration: underline;
    color: $control-content_secondary;

    &:hover:not(:active) {
      @include mf-breakpoint {
        color: $control_content_primary;
      }
    }
  }

  &_orange {
    color: $control-content_orange;

    &:hover:not(:active) {
      @include mf-breakpoint {
        color: $control-content_orange-hover;
      }
    }
  }

  &_black {
    &:hover:not(:active) {
      @include mf-breakpoint {
        color: $control-content_orange;
      }
    }
  }

  &_white {
    color: $control-content_white;

    &:hover:not(:active) {
      @include mf-breakpoint {
        color: $control-content_orange;
      }
    }
  }
}
</style>
